import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4a239da5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center",
  style: {"margin-bottom":"1.5rem"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shadow rounded-circle" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "d-flex justify-content-center align-items-center",
    style: {"width":"12rem","height":"12rem"}
  }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "spinner-border spinner-border text-primary",
      role: "status",
      "aria-hidden": "true"
    })
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "avatar avatar-huge cursor-pointer border border-4 border-card shadow rounded-circle" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle mt-3" }, "Alterar foto", -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'AvatarUploader',
  props: {
    uploading: { type: Boolean, default: false },
    inputId: { default: "avatar_uploader_input" },
    placeholder: { default: "" },
    avatar: { default: "" }
  },
  emits: ["onAvatarUploaded"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const openModalForFile = () => {
  document.getElementById(props.inputId)?.click();
};

const fileUploaded = async (event: any) => {
  emit("onAvatarUploaded", event);
};

return (_ctx: any,_cache: any) => {
  const _component_ImageCropper = _resolveComponent("ImageCropper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.uploading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: openModalForFile,
          class: "text-center"
        }, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.avatar)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.avatar,
                  class: "avatar-img rounded-circle"
                }, null, 8, _hoisted_5))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.placeholder,
                  class: "avatar-img rounded-circle"
                }, null, 8, _hoisted_6)),
            _hoisted_7
          ])
        ])),
    _createVNode(_component_ImageCropper, {
      modalId: "avatar_uploader_modal",
      accept: '.jpeg,.png,.jpg',
      aspectRatio: 1 / 1,
      onCropEnd: _cache[0] || (_cache[0] = ($event: any) => (fileUploaded($event))),
      inputId: "avatar_uploader_input",
      hiddenInput: true,
      backdrop: "false"
    })
  ], 64))
}
}

})